import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AlertType } from "../shared/constants/enums";

interface ToastState {
  isOpen: boolean;
  message: string;
  type: AlertType | "";
  duration: number;
}

export const toastInitialState: ToastState = {
  isOpen: false,
  message: "",
  type: AlertType.INFO,
  duration: 5000,
};

const toastSlice = createSlice({
  name: "toast",
  initialState: toastInitialState,
  reducers: {
    toast: (state, action: PayloadAction<Partial<ToastState>>) => {
      const { isOpen, message, type, duration } = action.payload;
      state.isOpen = isOpen ?? true;
      state.message = message ?? "";
      state.type = type ?? AlertType.INFO;
      state.duration = duration ?? 5000;
    },
    hideToast: (state) => {
      state.isOpen = false;
      state.message = "";
      state.type = "";
      state.duration = 5000;
    },
  },
});

export const { toast, hideToast } = toastSlice.actions;
export default toastSlice;
